export const environment = {
  production: false,
  appUrl: 'https://dev.desarrollaraucania.cl',
  ssoCookieName: 'cda_sso_token_dev',
  ssoCookieDomain: '.desarrollaraucania.cl',
  azureAd: {
    clientId: '3c22e143-ccf3-438f-ae78-5ce8cc587d54',
    authority: 'https://login.microsoftonline.com/967e8a1a-8459-4f2c-8542-eb98c979785c',
    redirectUri: 'https://dev.desarrollaraucania.cl',
    postLogoutRedirectUri: 'https://dev.desarrollaraucania.cl'
  },
  recaptcha: {
    siteKey: '6LfZhqosAAAAAGsC2vk7wgM-5T4KB2AdkSn59SS8'
  },
  // Paths relativos — en dev son proxeados por proxy.conf.json de Angular CLI
  apis: {
    base: '/api/v1',
    email: '/api/v1/email',
    documents: '/api/v1/documents',
    privateCenter: '/api/v1/private-center'
  },
  mfes: {
    chat: '/chat',
    hr: '/mfe/hr'
  }
};

